import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Courses from "./components/Courses";
import UpcomingAssignments from "./components/UpcomingAssignments";
import MagicAssignment from "./components/MagicAssignment";
import ReportCard from "./components/ReportCard";
import DeepLinkTool from "./components/DeepLinkTool"; // Import DeepLinkTool
import ShowUserInfo from "./components/ShowUserInfo"; // Import ShowUserInfo
import LTIAssignment from "./components/LTIAssignment"; // Import LTIAssignment
import CourseTutorTool from "./components/CourseTutorTool"; // Import CourseTutorTool
import UEFBase from "./components/UEFBase"; // Import UEFBase
import UEFBaseNav from "./components/UEFBaseNav";
import UEFCourseDetails from "./components/UEFCourseDetails";
import MessageCenterTool from "./components/MessageCenterTool";
import NotificationCenterTool from "./components/NotificationCenterTool";
import EventPublicationTool from "./components/EventPublicationTool";
import CourseDetails from "./components/CourseDetails"; // Import the CourseDetails component
import SetCategory from "./components/SetCategory";
import UploadRubric from "./components/UploadRubric";
import SportsAndStudents from "./components/SportsAndStudents";
import DownloadVideos from "./components/DownloadVideos";
import QuickEnroll from "./components/QuickEnroll";
import InstructorCourses from "./components/InstructorCourses";
import MyLocker from "./components/MyLocker";
import CourseContentLinks from "./components/CourseContentLinks";
import CourseLinks from "./components/CourseLinks";
import MyCourseLinks from "./components/MyCourseLinks";
import MyCourseWebLinks from "./components/MyCourseWebLinks";
import CourseContentPatterns from "./components/CourseContentPatterns";
import CourseContentSummary from "./components/CourseContentSummary";
import DataFlowDiagram from "./components/DataFlowDiagram";
import ProjectDeliverablesTable from "./components/ProjectDeliverablesTable";
import LatePenaltyRulesAdmin from "./components/LatePenaltyRulesAdmin";
import ContextDiagram from "./components/ContextDiagram";
import LatePenaltyCourseDetails from "./components/LatePenaltyCourseDetails";
import GradeHurdleCourseDetails from "./components/GradeHurdleCourseDetails";
import GradeHurdleAdmin from "./components/GradeHurdleAdmin";
import CourseChatWidget from "./components/CourseChatWidget";
import CourseCrawler from "./components/CourseCrawler";
import ExtraCreditRulesAdmin from "./components/ExtraCreditRulesAdmin";
import ExtraCreditCourseDetails from "./components/ExtraCreditCourseDetails";
import RubricsExportTool from "./components/RubricsExportTool";
import DeployExternalAssignTool from "./components/DeployExternalAssignTool";
import ExternalAssignment from "./components/ExternalAssignment";
import ScheduleGradesPosts from "./components/ScheduleGradesPosts";
import MigrateLtiLinks from "./components/MigrateLtiLinks";
import DeployContentWithLinks from "./components/DeployContentWithLinks";
import ConsultingCatalog from "./components/ConsultingCatalog";
import GradesJourneyAdmin from "./components/GradesJourneyAdmin";
import PathwaysAdmin from "./components/PathwaysAdmin";
import StudentPathways from "./components/StudentPathways";
import ComputeRegulatoryGrade from "./components/ComputeRegulatoryGrade";
import CatalogTaxesAdmin from "./components/CatalogTaxesAdmin";
import StudentTaxCalculator from "./components/StudentTaxCalculator";
import ChatPromptsAdmin from "./components/ChatPromptsAdmin";
import TrainingActivitySimulator from "./components/TrainingActivitySimulator";
import AppServer404LogsAdmin from "./components/AppServer404LogsAdmin";
import CourseAuditWidget from "./components/CourseAuditWidget";
import FacultyInteractionAgent from "./components/FacultyInteractionAgent";
import CourseBestPracticesAuditApp from "./components/CourseBestPracticesAuditApp";
import BlackboardAdoptionIndexTool from "./components/BlackboardAdoptionIndexTool";
import SkillsDefinitionTool from "./components/SkillsDefinitionTool";
import QtiConverterWidget from "./components/QtiConverterWidget";
import CustomAdoptionIndexTool from "./components/CustomAdoptionIndexTool";

function App() {
    return (
        <div className="bb-container">
            <Router>
                <Routes>
                    <Route path="/" element={<ConditionalRoute />} />
                </Routes>
            </Router>
        </div>
    );
}

function ConditionalRoute() {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    // Retrieve query parameters
    const route = queryParams.get("route");
    const encodedState = queryParams.get("state");

    // Decode and parse the `state` parameter if it exists
    let state = {};
    if (encodedState) {
        try {
            state = JSON.parse(decodeURIComponent(atob(encodedState))); // Base64 decode and parse
        } catch (error) {
            console.error("Failed to decode state:", error);
        }
    }

    let locale = state.locale?.replaceAll("-", "_");

    console.log ('platformUrl: ' + state.platformUrl);
    console.log ('locale: ' + locale);
    console.log ('courseId: ' + localStorage.getItem('courseId'));
    if (route === "MyCourses") {
        return <Courses platformUrl={state.platformUrl}/>;
    }

    if (route === "GradesJourneyAdmin") {
        return <GradesJourneyAdmin platformUrl={state.platformUrl} backEndUrl={state.backendUrl}/>;
    }

    if (route === "Assignments") {
        return <UpcomingAssignments platformUrl={state.platformUrl}/>;
    }

    if (route === "MagicAssignment") {
        return <MagicAssignment />;
    }

    if (route === "ReportCard") {
        return <ReportCard platformUrl={state.platformUrl}/>;
    }

    if (route === "DeepLinkTool") {
        return <DeepLinkTool backEndUrl={state.backendUrl} encodedState={encodedState} />;
    }

    if (route === "DeployExternalAssignTool") {
        return <DeployExternalAssignTool tenantId={state.tenantId} backEndUrl={state.backendUrl} encodedState={encodedState} />;
    }

    if (route === "ComputeRegulatoryGrade") {
        return <ComputeRegulatoryGrade platformUrl={state.platformUrl}/>;
    }

    if (route === "ShowUserInfo") {
        return <ShowUserInfo platformUrl={state.platformUrl}/>;
    }

    if (route === "ConsultingCatalog") {
        return <ConsultingCatalog platformUrl={state.platformUrl} backEndUrl={state.backendUrl} />;
    }

    if (route === "StudentTaxCalculator") {
        return <StudentTaxCalculator currencyCode={state.currencyCode} autoCompute={state.autoCompute} itemCost={state.itemCost} platformUrl={state.platformUrl} backEndUrl={state.backendUrl} tenantId={state.tenantId}/>;
    }

    if (route === "CatalogTaxesAdmin") {
        return <CatalogTaxesAdmin platformUrl={state.platformUrl} backEndUrl={state.backendUrl} tenantId={state.tenantId}/>;
    }

    if (route === "ChatPromptsAdmin") {
        return <ChatPromptsAdmin platformUrl={state.platformUrl} backEndUrl={state.backendUrl} tenantId={state.tenantId}/>;
    }

    if (route === "CourseBestPracticesAuditApp") {
        return <CourseBestPracticesAuditApp platformUrl={state.platformUrl} backEndUrl={state.backendUrl} tenantId={state.tenantId}/>;
    }

    if (route === "BlackboardAdoptionIndexTool") {
        return <BlackboardAdoptionIndexTool platformUrl={state.platformUrl} backEndUrl={state.backendUrl} tenantId={state.tenantId}/>;
    }

    if (route === "CustomAdoptionIndexTool") {
        return <CustomAdoptionIndexTool platformUrl={state.platformUrl} backEndUrl={state.backendUrl} tenantId={state.tenantId}/>;
    }

    if (route === "PathwaysAdmin") {
        return <PathwaysAdmin platformUrl={state.platformUrl} backEndUrl={state.backendUrl} />;
    }

    if (route === "StudentPathways") {
        return <StudentPathways platformUrl={state.platformUrl} backEndUrl={state.backendUrl} />;
    }

    if (route === "LTIAssignment") {
        return <LTIAssignment lineItemUrl={state.lineItemUrl} platformUrl={state.platformUrl} backEndUrl={state.backendUrl}/>;
    }

    if (route === "ExternalAssignment") {
        return <ExternalAssignment tenantId={state.tenantId} resourceId={state.resourceId} lineItemUrl={state.lineItemUrl} platformUrl={state.platformUrl} backEndUrl={state.backendUrl}/>;
    }

    if (route === "CourseAuditWidget") {
        return <CourseAuditWidget tenantId={state.tenantId} platformUrl={state.platformUrl} backEndUrl={state.backendUrl}/>;
    }

    if (route === "QtiConverterWidget") {
        return <QtiConverterWidget tenantId={state.tenantId} platformUrl={state.platformUrl} backEndUrl={state.backendUrl}/>;
    }

    if (route === "FacultyInteractionAgent") {
        return <FacultyInteractionAgent tenantId={state.tenantId} platformUrl={state.platformUrl} backEndUrl={state.backendUrl}/>;
    }

    if (route === "DeployContentWithLinks") {
        return <DeployContentWithLinks tenantId={state.tenantId} mode={state.mode} platformUrl={state.platformUrl} backEndUrl={state.backendUrl}
                                       resourceId={state.resourceId} encodedState={encodedState} deployedCourseKey={state.deployedCourseKey}
                                       deployedResourceId={state.deployedResourceId} deployedCourseKeyType={state.deployedCourseKeyType}/>;
    }

    if (route === "CourseTutorTool") {
        return <CourseTutorTool platformUrl={state.platformUrl} backEndUrl={state.backendUrl}/>;
    }

    if (route === "TrainingActivitySimulator") {
        return <TrainingActivitySimulator tenantId={state.tenantId} platformUrl={state.platformUrl} backEndUrl={state.backendUrl}/>;
    }

    if (route === "GradeHurdleAdmin") {
        return <GradeHurdleAdmin tenantId={state.tenantId} platformUrl={state.platformUrl} backEndUrl={state.backendUrl}/>;
    }

    if (route === "AppServer404LogsAdmin") {
        return <AppServer404LogsAdmin tenantId={state.tenantId} platformUrl={state.platformUrl} backEndUrl={state.backendUrl}/>;
    }

    if (route === "CourseChatWidget") {
        return <CourseChatWidget platformUrl={state.platformUrl} backEndUrl={state.backendUrl} tenantId={state.tenantId}/>;
    }

    if (route === "SkillsDefinitionTool") {
        return <SkillsDefinitionTool platformUrl={state.platformUrl} backEndUrl={state.backendUrl} tenantId={state.tenantId}/>;
    }

    if (route === "UEFBase") {
        return <UEFBase platformUrl={state.platformUrl} />;
    }

    if (route === "UEFBaseNav") {
        return <UEFBaseNav platformUrl={state.platformUrl} />;
    }

    if (route === "UEFCourseDetails") {
        return <UEFCourseDetails platformUrl={state.platformUrl} />;
    }

    if (route === "CourseCrawler") {
        return <CourseCrawler platformUrl={state.platformUrl} />;
    }

    if (route === "MigrateLtiLinks") {
        return <MigrateLtiLinks platformUrl={state.platformUrl} />;
    }

    if (route === "GradeHurdleCourseDetails") {
        return <GradeHurdleCourseDetails tenantId={state.tenantId} platformUrl={state.platformUrl} backEndUrl={state.backendUrl} />;
    }

    if (route === "LatePenaltyCourseDetails") {
        return <LatePenaltyCourseDetails tenantId={state.tenantId} platformUrl={state.platformUrl} backEndUrl={state.backendUrl} />;
    }

    if (route === "ExtraCreditCourseDetails") {
        return <ExtraCreditCourseDetails tenantId={state.tenantId} platformUrl={state.platformUrl} backEndUrl={state.backendUrl} />;
    }

    if (route === "MessageCenterTool") {
        return <MessageCenterTool backEndUrl={state.backendUrl} platformUrl={state.platformUrl} />;
    }

    if (route === "NotificationCenterTool") {
        return <NotificationCenterTool backEndUrl={state.backendUrl} platformUrl={state.platformUrl} />;
    }

    if (route === "EventPublicationTool") {
        return <EventPublicationTool backEndUrl={state.backendUrl} platformUrl={state.platformUrl} />;
    }

    if (route === "CourseDetails") {
        return <CourseDetails platformUrl={state.platformUrl} />;
    }

    if (route === "RubricsExportTool") {
        return <RubricsExportTool platformUrl={state.platformUrl} />;
    }

    if (route === "SetCategory") {
        return <SetCategory platformUrl={state.platformUrl} />;
    }

    if (route === "UploadRubric") {
        return <UploadRubric platformUrl={state.platformUrl} />;
    }

    if (route === "InstructorCourses") {
        return <InstructorCourses platformUrl={state.platformUrl} />;
    }

    if (route === "SportsAndStudents") {
        return <SportsAndStudents backEndUrl={state.backendUrl}/>;
    }

    if (route === "DownloadVideos") {
        return <DownloadVideos backEndUrl={state.backendUrl}/>;
    }

    if (route === "QuickEnroll") {
        return <QuickEnroll backEndUrl={state.backendUrl} platformUrl={state.platformUrl}/>;
    }

    if (route === "MyLocker") {
        return <MyLocker backEndUrl={state.backendUrl} platformUrl={state.platformUrl}/>;
    }

    if (route === "CourseContentLinks") {
        return <CourseContentLinks backEndUrl={state.backendUrl} platformUrl={state.platformUrl}/>;
    }

    if (route === "CourseLinks") {
        return <CourseLinks backEndUrl={state.backendUrl} platformUrl={state.platformUrl}/>;
    }

    if (route === "MyCourseLinks") {
        return <MyCourseLinks backEndUrl={state.backendUrl} platformUrl={state.platformUrl}/>;
    }

    if (route === "MyCourseWebLinks") {
        return <MyCourseWebLinks backEndUrl={state.backendUrl} platformUrl={state.platformUrl}/>;
    }

    if (route === "CourseContentPatterns") {
        return <CourseContentPatterns backEndUrl={state.backendUrl} platformUrl={state.platformUrl}/>;
    }

    if (route === "CourseContentSummary") {
        return <CourseContentSummary backEndUrl={state.backendUrl} platformUrl={state.platformUrl}/>;
    }

    if (route === "LatePenaltyRulesAdmin") {
        return <LatePenaltyRulesAdmin tenantId={state.tenantId} backEndUrl={state.backendUrl} platformUrl={state.platformUrl}/>;
    }

    if (route === "ScheduleGradesPosts") {
        return <ScheduleGradesPosts tenantId={state.tenantId} backEndUrl={state.backendUrl} platformUrl={state.platformUrl}/>;
    }

    if (route === "ExtraCreditRulesAdmin") {
        return <ExtraCreditRulesAdmin tenantId={state.tenantId} backEndUrl={state.backendUrl} platformUrl={state.platformUrl}/>;
    }

    if (route === "DataFlowDiagram") {
        return <DataFlowDiagram />;
    }

    if (route === "ContextDiagram") {
        return <ContextDiagram />;
    }

    if (route === "ProjectDeliverablesTable") {
        return <ProjectDeliverablesTable platformUrl={state.platformUrl} backEndUrl={state.backendUrl} role={state.role}/>;
    }

    return <RouteNotFound />;
}

function RouteNotFound() {
    return (
        <div style={{ textAlign: "center", marginTop: "50px" }}>
            <h1>Route Not Found</h1>
            <p>The specified route does not exist. Please check the query parameter.</p>
        </div>
    );
}

export default App;
